import { useEffect, useState } from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useLocation } from "react-router-dom";
import { trackEvent } from "../../analytics";
import hervestLogo from "../../assets/images/hervestLogo.svg";

// Smart link: sends iOS to the App Store and Android to Google Play.
const APP_LINK = "https://hervestng.app.link/";
const STORAGE_KEY = "appBannerDismissedAt";
const HIDE_FOR_MS = 7 * 24 * 60 * 60 * 1000;
const SHOW_DELAY_MS = 5000;
// Don't interrupt money / security flows.
const HIDDEN_ROUTE_PARTS = ["pin", "otp", "verify", "confirm", "payment"];

const recentlyDismissed = () => {
  try {
    const at = Number(localStorage.getItem(STORAGE_KEY));
    return at && Date.now() - at < HIDE_FOR_MS;
  } catch (e) {
    return false;
  }
};

const AppDownloadBanner = () => {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (recentlyDismissed()) return;
    const timer = setTimeout(() => {
      setVisible(true);
      trackEvent("app_banner_shown");
    }, SHOW_DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  const onRoute = HIDDEN_ROUTE_PARTS.some((part) =>
    pathname.toLowerCase().includes(part)
  );
  if (!visible || onRoute) return null;

  const dismiss = () => {
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch (e) {
      // storage unavailable: just hide for this session
    }
    trackEvent("app_banner_dismissed");
    setVisible(false);
  };

  return (
    <div
      role="complementary"
      className="fixed z-40 bottom-4 right-4 left-4 sm:left-auto sm:w-[360px] bg-white rounded-2xl shadow-xl border border-[#EBDDE7] p-4 flex items-center gap-3"
    >
      <img src={hervestLogo} alt="" className="h-10 w-10 shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-[14px] font-bold text-[#5B2E4F] leading-4">
          Get the HerVest app
        </p>
        <p className="text-[12px] text-[#33343D] leading-4 mt-1">
          Download for a seamless, faster experience and instant alerts.
        </p>
        <a
          href={APP_LINK}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackEvent("app_banner_clicked")}
          className="inline-block mt-2 bg-[#5B2E4F] text-white text-[12px] font-bold px-4 py-2 rounded-lg"
        >
          Download app
        </a>
      </div>
      <button
        type="button"
        onClick={dismiss}
        aria-label="Dismiss"
        className="self-start text-gray-400 hover:text-gray-600"
      >
        <XMarkIcon className="h-5 w-5" />
      </button>
    </div>
  );
};

export default AppDownloadBanner;
